export const ACTIONS = {
    tenant: [
        'list',
        'create',
        'read',
        'update',
        'offboard',
        'suspend',
        'resume',
        'change-tier',
        'adopt-package',
        'reapply-package',
        'retry',
    ],
    package: ['list', 'create', 'read', 'update', 'retire'],
    tier: ['list'],
    cell: ['list'],
    product: ['list'],
    directory: ['read'],
    admin: ['list', 'create', 'read', 'remove'],
    menu: ['read'],
    metering: ['ingest', 'read'],
    workspace: ['read'],
    entitlement: ['read'],
    catalog: ['read'],
    signup: ['create', 'read'],
    me: ['read', 'consent'],
    membership: ['list', 'read', 'update', 'remove'],
    invitation: ['list', 'create', 'read', 'revoke', 'resend'],
    contact: ['list', 'create', 'read', 'write', 'delete', 'reassign', 'move-office'],
    billing: ['read'],
    checkout: ['create'],
    portal: ['create'],
    subscription: ['list', 'read', 'adjust'],
    webhook: ['receive'],
    notification: ['list', 'read'],
    consent: ['list', 'record'],
    device: ['list', 'register', 'remove'],
    preference: ['read', 'update'],
    audit: ['list'],
    assistant: ['converse', 'read-usage'],
    export: ['create', 'read'],
    deletion: ['request', 'cancel'],
    notice: ['list', 'acknowledge'],
    announcement: ['list', 'publish', 'withdraw'],
};
export const ACTION_PATTERN = /^[a-z][a-z0-9-]*:[a-z][a-z0-9-]*$/;
export function isAction(value) {
    const [kind, verb] = value.split(':');
    if (!kind || !verb)
        return false;
    const verbs = ACTIONS[kind];
    return verbs !== undefined && verbs.includes(verb);
}
export function splitAction(action) {
    const [kind, verb] = action.split(':');
    return { kind, verb };
}
/** Every action, for exhaustive tests. */
export function allActions() {
    const out = [];
    for (const [kind, verbs] of Object.entries(ACTIONS)) {
        for (const verb of verbs)
            out.push(`${kind}:${verb}`);
    }
    return out;
}
//# sourceMappingURL=actions.js.map